import ifElse from 'ramda/src/ifElse'
import propOr from 'ramda/src/propOr'
import pageContentSelector from 'root/src/client/logic/static/selectors/pageContentSelector'
import anyPass from 'ramda/src/anyPass'
import pipe from 'ramda/src/pipe'
import prop from 'ramda/src/prop'
import isNil from 'ramda/src/isNil'
import includes from 'ramda/src/includes'
import __ from 'ramda/src/__'
import userGroupsSelector from 'root/src/client/logic/auth/selectors/userGroupsSelector'

export default (state, { moduleId }) => {
	const pageContent = pageContentSelector(state, { moduleId })
	const buttons = propOr([], 'buttons', pageContent)
	const userGroups = userGroupsSelector(state)

	return buttons
		.filter(
			ifElse(
				prop('buttonSelector'),
				pipe(
					prop('buttonSelector'),
					fn => fn(state),
				),
				pipe(
					prop('authenticationRole'),
					anyPass([
						isNil,
						includes(__, userGroups),
					]),
				),
			),
		)
}
